export const errorMessage = {
    400001: '金啾拍謝發生非預期錯誤(400001)',
    400002: '此門號已是金啾會員快來登入吧！',
    400003: '此門號尚未註冊先成為會員吧！',
    400004: '證件無法辨識請確保無反光昏暗並重新上傳',
    // 400005: 'WALLET_IS_NOT_ENOUGH',
    400006: 'PDF 產生中請稍候再試',
    400007: '此身分證字號已被使用',
    400008: '尚有帳單未繳納\n無法進行簽約',
    400009: '不能與自己簽約哦',
    400010: '此統一編號已被使用',
    400011: '此簽約已完成',
    400012: '此簽約已取消',
    // 400013: 'For 有權限設定組織信用卡：尚未設定付費方式，前往設定 For 無權限者：Toast 組織未綁定信用卡\n請聯絡組織管理者',
    // 400014: 'For 有權限設定組織信用卡：建議重新綁定信用/簽帳金融卡後再試\n若仍無法解決，請詢問客服 For 無權限者：Toast 刷卡失敗\n聯絡組織管理者或客服',
    400015: '已設定完成，無法重新編輯',
    401001: '金啾拍謝發生非預期錯誤(401001)',
    401002: '金啾拍謝發生非預期錯誤(401002)',
    401003: '為了保護您的帳戶安全煩請重新登入(401003)',
    // 401004: 'RefreshToken and Retry Request If failed Toast',
    401005: '為了保護您的帳戶安全煩請重新登入(401005)',
    401006: '為了保護您的帳戶安全煩請重新登入(401006)',
    401007: '金啾拍謝發生非預期錯誤(401007)',
    401008: '簡訊驗證碼已過期',
    401009: '抱歉，你的帳號發生問題，請從平台官網聯繫客服',
    403001: '金啾拍謝發生非預期錯誤(403001)',
    403002: '實名制未通過',
    403003: '金啾拍謝發生非預期錯誤(403003)',
    403004: '未授權的應用程式(403004)',
    404001: '金啾拍謝發生非預期錯誤(404001)',
    422001: '金啾拍謝發生非預期錯誤(422001)',
    502001: '金啾拍謝簡訊服務異常',
    502006: '讀取發生異常檢查設備憑證、編號後再試',
}

export const getErrorMessage = (errorCode) => {
    return errorMessage[errorCode] || ''
}
